import {Dialog as DialogDLS} from '@mediwareinc/wellsky-dls-react';
import ReactDOM from 'react-dom/client';
import {ThemeProvider} from '@/services/theme';

class ConfirmationDialog {
  visible = false;

  show(message) {
    return new Promise((resolve) => {
      if (document && !this.visible) {
        const container = document.createElement('div');
        container.setAttribute('id', 'confirmation-dialog');
        const root = ReactDOM.createRoot(container);
        this.visible = true;

        const handleAction = (data) => {
          resolve(data);
          root.unmount();
          this.visible = false;
        };

        root.render(
          <ThemeProvider>
            <DialogDLS
              className="confirmation-dialog"
              title="Confirmation"
              isOpen={true}
              okLabel="Confirm"
              cancelLabel="Cancel"
              cancelOnClick={() => handleAction({confirmation: false})}
              okOnClick={() => handleAction({confirmation: true})}
              onClose={() => handleAction({confirmation: false})}
            >
              {message}
            </DialogDLS>
          </ThemeProvider>,
        );

        // This is a hack to remove focus from the button that was clicked
        setTimeout(() => {
          document
            .querySelectorAll('section[id^="chakra-modal"] button')
            .forEach((button) => {
              button.blur();
            });
        }, 0);
      }
    });
  }
}

export const confirmationDialog = new ConfirmationDialog();
